import { render, staticRenderFns } from "./CodeDocsLayout.vue?vue&type=template&id=24cbc5c6"
import script from "./CodeDocsLayout.vue?vue&type=script&lang=js"
export * from "./CodeDocsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports